<!-- Card -->
<div class="card">
  <div class="view rgba-white-slight waves-light">
    <!-- Card img -->
    <img class="card-img-top" src="{{member.picLink ? member.picLink : 'assets/img/gallery-img/Dreiherrenspitze.jpg'}}" alt="member">
    <a>
      <div class="mask"></div>
    </a>
  </div>
  <!--Card content-->
  <div class="card-body">
    <!--Title-->
    <div style="text-align: center">
      <h4>{{member.name}}</h4>
    </div>

    <!--Text-->
    <div class="card-text">
      @if (member.email) {
      <p>
       
          <i class="fas fa-envelope" style="margin-right: .1rem !important;"></i> <a href="mailto:{{member.email}}">{{member.email}}</a>
          </p>
      }
      @if (member.website) {
        <p>
          <i class="fas fa-home" style="margin-right: .1rem !important;"></i> <a href="{{member.website}}">{{member.shortWebUri}}</a>
        </p>
      }
      @if (member.phone) {
        <p>
          <i class="fas fa-phone" style="margin-right: .1rem !important;"></i> {{member.phone}}
        </p>
      }
    </div>
  </div>
</div>
<!-- Card -->
